import { SVGProps, Ref, forwardRef } from 'react';

export const BoltFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.875 7.426 5.307 9.802c-1.804 2.732-2.705 4.098-2.139 5.15s2.203 1.053 5.477 1.053h1.14c.014 4.352.149 6.566 1.423 6.949 1.425.427 2.921-1.84 5.914-6.375l1.568-2.376c1.803-2.732 2.705-4.099 2.138-5.15C20.262 8 18.625 8 15.351 8h-1.14c-.014-4.352-.148-6.566-1.423-6.949-1.425-.428-2.92 1.84-5.913 6.375"
                fill="currentColor"
            />
        </g>
    </svg>
));
BoltFilledSize24Glyph.displayName = 'BoltFilledSize24Glyph';
